export default {
  common: {
    ok: "确定",
    cancel: "取消",
    brand: "Forward",
    slogan: "心怀感恩地转发。<br>带着<b>意图</b>去创造。",
    intro: "每一张收据，都证明金钱曾流经你的生活与事业。心怀感恩地转发它，觉察每一笔钱的去向，在一次次有意识的选择中吸引并积累财富。",
    switchLanguage: "切换语言"
  },
  header: {
    blog: "博客",
    features: "功能",
    subscription: "订阅",
    faq: "常见问题",
    contact: "联系",
    startFreeTrial: "开始免费试用"
  },
  footer: {
    desc: "心怀感恩地转发每一张收据。让 AI 整理细节，帮助你与金钱建立更清晰、更有意识的关系。",
    productHelp: "产品帮助",
    privacyPolicy: "隐私政策",
    termsConditions: "条款和条件",
    deleteAccount: "删除账户",
    contactInfo: "联系信息",
    email: "邮箱：support@forwardreceipts.com",
    officeHour: "办公时间：周一至周五，上午 9 点–下午 6 点（GMT+8）",
    copyright: "2026 Impulz Digital Pte Ltd. 保留所有权利。"
  },
  hero: {
    eyebrow: "自由职业者的每日金钱仪式",
    homeIntro: "每一张收据，都证明金钱曾流经你的生活与事业。心怀感恩地转发它，觉察每一笔钱的去向，在一次次有意识的选择中吸引并积累财富。",
    appStoreAlt: "在 App Store 下载",
    googlePlayAlt: "在 Google Play 获取",
    freeTrialTitle: "免费试用",
    freeTrialDesc: "从完全免费的计划开始 <br> 探索所有核心功能。",
    startFreeTitle: "免费开始",
    startFreeDesc: "先试用再决定。 <br> 无压力，无绑定。",
    builtForRealLifeTitle: "为真实生活打造。",
    builtForRealLifeDesc: "收据不会停止。你也不应该。转发它，忘掉它。",
    supportTitle: "及时出现的支持。",
    supportDesc: "给我们发邮件。我们就在这里。",
    oneActionTitle: "一个动作。",
    oneActionDesc: "转发收据。完成。"
  },
  features: {
    featureLabel: "功能",
    receiptInboxTitle: "您专属的收据收件箱",
    receiptInboxDesc1: "无需手动上传",
    receiptInboxDesc2: "一次发送一张或多张收据",
    receiptInboxDesc3: "与商家电子收据即时配合",
    receiptInboxSummary: "这是核心习惯：转发它，忘掉它。",
    autoExtractTitle: "自动提取收据详情",
    autoExtractDesc: "我们自动提取关键信息：",
    autoExtractMerchant: "商家",
    autoExtractAmount: "金额",
    autoExtractDate: "日期",
    autoExtractTax: "税费",
    autoExtractSummary: "适用于全球各种语言和收据格式——无需额外步骤。",
    globalReadyTitle: "面向全球",
    globalReadyDesc: "收据不分国界。",
    globalReadyPoint1: "多币种支持",
    globalReadyPoint2: "自动货币转换",
    globalReadyPoint3: "清晰一致的记录——随时可用",
    multiOrgTitle: "多个组织",
    multiOrgDesc: "在一个账户下管理多个企业、项目或客户。",
    multiOrgPoint1: "保持支出清晰分离",
    multiOrgPoint2: "无需切换工具即可切换上下文",
    teamAccessTitle: "团队访问（按需）",
    teamAccessDesc: "邀请队友一起转发、审查和导出收据。",
    teamAccessPoint1: "基于角色的访问",
    teamAccessPoint2: "清晰的权限归属",
    teamAccessPoint3: "无需混乱交接",
    easyExportTitle: "轻松导出",
    easyExportDesc: "当需要进行会计或报税时：",
    easyExportPoint1: "将收据和数据导出为 CSV 或 PDF",
    easyExportPoint2: "立即与会计师或簿记员共享",
    easyExportPoint3: "无需重新格式化",
    startSteps: {
      startFree: "免费开始",
      startFreeTitle: "创建你的空间",
      startFreeDesc: "无需提供付款信息，几分钟内即可完成账户设置。",
      mailFile: "心怀感恩地转发",
      mailFileTitle: "觉察每一次交换",
      mailFileDesc: "每张收据都提醒你：金钱曾支持你的工作、生活或成长。",
      support: "交给 AI 整理",
      supportTitle: "放下行政琐事",
      supportDesc: "无需手动录入，我们会自动提取、分类并保存详细信息。",
      oneAction: "建立财务觉察",
      oneActionTitle: "清楚看见你的金钱",
      oneActionDesc: "随着时间推移，收据会呈现出规律，帮助你做出更有意识的决定。"
    },
    startBlock: {
      label: "开始这项练习",
      title: "为更有意识的财务生活，<br/><b>建立一个简单的日常仪式。</b>",
      desc: "免费开始，创建你的专属转发地址，让每一张收据都成为一次短暂的感恩与觉察。只需转发一次，其余整理工作交给 Forward Receipts 自动完成。",
      cta: "开始你的金钱仪式"
    },
    receiptReady: {
      label: "轻松觉察",
      title: "让关注金钱变得简单。",
      intro: "从任何邮箱转发收据，让支出始终清晰可见，同时避免让财务觉察变成另一项令人疲惫的任务。",
      items: [
        { title: "无需复杂引导", desc: "快速开始，让这个习惯自然融入日常。" },
        { title: "多个邮箱，同一套习惯", desc: "将每个邮箱中的收据转发到同一个有意识的管理系统。" },
        { title: "看见每一次交换", desc: "让财务记录保持实时更新，不必等到报税时才面对。" },
        { title: "自动整理", desc: "让技术处理细节，你只需关注金钱背后的意义。" }
      ]
    },
    autoDetails: {
      label: "自动费用详情",
      title: "尊重每一个细节，<br/>不必亲自处理琐事。",
      intro: "Forward Receipts 会自动读取每张收据，保留有助于你理解并尊重每一笔业务支出的关键信息。",
      items: [
        { title: "商家与来源", desc: "记住每一笔钱流向了哪里。" },
        { title: "日期与时间", desc: "看见每一次金钱交换发生的时刻。" },
        { title: "金额与币种", desc: "让每一笔消费的价值清晰可见。" },
        { title: "税费与项目明细", desc: "自动记录完整的财务信息。" }
      ]
    },
    globalReadyNew: {
      label: "全球财富视野",
      title: "你的金钱故事不受国界限制。",
      intro: "无论你在国际市场赚钱、消费还是旅行，Forward Receipts 都会将每张收据汇入一个清晰的财务视图。",
      items: [
        { title: "支持任何国家的收据", desc: "无论交换发生在哪里，都能妥善保留。" },
        { title: "支持多种货币", desc: "理解流经不同市场的金钱。" },
        { title: "自动换算", desc: "无需手动计算，也能查看统一的金额。" },
        { title: "适应地区的记录", desc: "跨地区整理实用的财务信息。" }
      ]
    },
    multipleOrganizations: {
      label: "每项事业，同一个愿景",
      title: "在每个项目中持续创造财富。",
      intro: "自由职业者经常同时管理多个客户、项目与收入来源。既能清晰区分每一项，也能看见它们如何共同构成你正在创造的财务生活。",
      items: [
        { title: "分离不同支出流", desc: "为每个项目建立清晰独立的财务记录。" },
        { title: "即时切换", desc: "在不同事业之间切换，同时保持全局视角。" },
        { title: "一致的金钱可见性", desc: "让金额与币种始终易于理解。" },
        { title: "统一报告", desc: "同时看清单个项目与整体财务情况。" }
      ]
    },
    teamAccessNew: {
      label: "共同的意图",
      title: "与同样尊重金钱的人一起创造。",
      intro: "邀请协作者共同转发、审核和整理收据，让财务觉察成为团队运作方式的一部分。",
      items: [
        { title: "周全的权限设置", desc: "只为每个人提供真正需要的访问权限。" },
        { title: "有意义的标注", desc: "补充背景，让每笔费用讲述完整的故事。" },
        { title: "会计可用的导出", desc: "把每日觉察转化为整洁专业的记录。" },
        { title: "协作中的清晰", desc: "让每个人都清楚金钱流向何处。" }
      ]
    },
    easyExportsNew: {
      label: "从容面对报税季",
      title: "把每日的感恩，沉淀为长期的秩序。",
      intro: "因为你一路上都及时确认并转发了每张收据，报税季只需从容交接，而不是匆忙清算。",
      items: [
        { title: "导出整洁的 CSV、PDF 或税务数据", desc: "无需临时整理，即可向会计交付有序记录。" },
        { title: "连接你的会计工具", desc: "将有意识的金钱管理方式延伸到整个工作流程。" },
        { title: "无需最后一刻重新排版", desc: "因为习惯发生在每天，记录早已准备妥当。" }
      ]
    }
  },
  promo: {
    freeTitle: "免费开始",
    freeDesc: "无需信用卡，也无需任何承诺，轻松开始你的金钱仪式。",
    easyTitle: "只需一个动作",
    easyDesc: "趁这笔消费仍清晰时，把收据转发出去。",
    supportTitle: "为自由职业者打造",
    supportDesc: "随时看清业务支出，不再增加新的行政负担。",
    smartTitle: "持续累积的清晰感",
    smartDesc: "让 AI 整理细节，把你的注意力留给更好的金钱决策。"
  },
  newsletter: {
    ritualKicker: "Forward Receipts 的理念",
    ctaTitle: "一张收据一次，建立每日<strong>吸引财富</strong>的仪式。",
    ctaDesc: "收据证明金钱曾经流动、价值曾经交换。带着意图转发，不带评判地回顾，让每日觉察逐渐成为更明智的财务决策。",
    ritualSteps: [
      {
        title: "心怀感恩地接收",
        desc: "收据证明金钱曾经流动、价值曾经交换。停下来呼吸片刻，觉察这笔消费为你支持了什么。"
      },
      {
        title: "带着意图转发",
        desc: "将收据发送至 Forward Receipts。这个小小的动作代表：我关注自己的金钱，也尊重流经生活与事业的每一笔价值。"
      },
      {
        title: "不带评判地回顾",
        desc: "随着收据逐渐积累，规律也会浮现。用它们获得诚实的觉察、做出更明智的决定，并逐步看清吸引财富的路径。"
      }
    ],
    tryFree: "开始你的金钱仪式",
    googlePlay: "Google Play",
    appStore: "App Store"
  },
  pricing: {
    kicker: "选择适合你的练习方式",
    mostPopular: "MOST POPULAR",
    sectionTitle: "为有意识的成长提供简单定价。",
    sectionDesc: "从今天适合你的支持级别开始，随着事业和财务生活的发展再逐步升级。",
    starterPlan: {
      name: "STARTER 免费",
      price: "$0",
      desc: "适合开始培养每日金钱觉察习惯的自由职业者。",
      features: [
        "1 个账户",
        "每月最多 100 张收据",
        "邮件转发",
        "基础分类",
        "CSV 导出",
        "标准支持"
      ],
      cta: "免费开始"
    },
    proPlan: {
      name: "Pro",
      price: "$9.99",
      period: "/月",
      desc: "适合准备看见并塑造自身财务模式的独立专业人士。",
      features: [
        "最多 5 个账户",
        "每月 1,000 张收据",
        "共享收件箱转发",
        "智能分类规则",
        "高级导出（CSV + PDF）",
        "基础分析仪表板",
        "优先支持"
      ],
      cta: "开始使用 Pro"
    },
    scalePlan: {
      name: "SCALE",
      price: "$49",
      period: "/月",
      desc: "适合通过共同的财务清晰度创造财富的成长型团队。",
      features: [
        "最多 50 个账户",
        "每月 10,000 张收据",
        "团队权限",
        "API 访问",
        "多组织管理",
        "自定义转发别名",
        "Slack + 会计集成",
        "高级分析"
      ],
      cta: "开始使用 Scale"
    },
    enterprisePlan: {
      name: "ENTERPRISE",
      price: "定制",
      period: "",
      desc: "适合将有意识的金钱管理融入日常运营的组织。",
      features: [
        "最多 1,000 个账户",
        "无限收据",
        "SSO + SAML",
        "自定义域名转发",
        "专属入职指导",
        "审计日志",
        "企业级安全",
        "SLA 支持"
      ],
      cta: "联系我们"
    }
  },
  faq: {
    sectionTitle: "常见问题",
    kicker: "开始之前的问题",
    heading: "常见问题",
    contactPrefix: "没有找到答案？",
    contactLink: "给我们发邮件",
    projectCtaTitle: "用 Forward 开始你的项目。",
    projectCtaDesc: "我们会通过邮件向你介绍产品。",
    emailPlaceholder: "你的邮箱",
    subscribe: "订阅",
    registerQ: "如何注册？",
    registerA: "下载应用，并在一分钟内创建账户。然后转发你的第一张收据，迈出与金钱建立更有意识关系的第一小步。",
    uploadQ: "如何上传收据？",
    uploadA: "从任何邮箱转发收据。你也可以在应用中扫描或上传收据，AI 会自动提取并整理详细信息。",
    supportQ: "如何联系支持？",
    supportA: "随时发送邮件至 <a href='mailto:support@forwardreceipts.com'>support@forwardreceipts.com</a>，我们的真人客服会尽快回复。",
    inviteQ: "如何邀请团队成员？",
    inviteA: "添加成员的邮箱地址，选择他们所需的访问权限，即可邀请他们与你一起转发、审核和整理收据。",
    freeQ: "应用免费吗？",
    freeA: "是的。你可以从免费方案开始，仅在需要更多收据额度、账户或协作功能时升级。",
    changePlanQ: "如何更改我的计划？",
    changePlanA: "打开“设置”，选择符合需求的方案并确认更改。你可以随时升级或降级。"
  },
  privacy: {
    title: "隐私政策",
    policyIntro:
      "在 Impulz Digital Pte Ltd, Inc（以下简称“我们”），我们最重要的资产是与用户社区的关系。我们致力于保障您的在线隐私。本隐私政策（“隐私政策”或“政策”）描述了当您通过我们的移动应用程序（“Forwardreceipts 应用程序”）使用我们的费用管理、开票或账单处理软件时，我们如何收集、使用、披露、共享和保护您提供的个人和公司信息。它还描述了您在个人数据的使用、访问和更正方面的选择。",
    userDefinition:
      "在本隐私政策中，“您”指 Forwardreceipts 应用程序的个人用户，以及会员和企业会员。",
    processDataNotice:
      "我们按照本隐私政策的规定处理您的个人数据，请您仔细阅读。",
    additionalRightsNotice:
      "如果您位于欧盟/英国、加利福尼亚州（美国）或新加坡，根据适用的数据保护法律，您可能拥有额外的权利。请仔细阅读本隐私政策以了解您的权利。",
    section1Title: "1. 我们收集哪些数据？",
    personalDataDef:
      "个人信息或“个人数据”是指关于个人的、可以识别该身份的任何信息，或者当与 Forwardreceipts 应用程序已经持有或可能持有的其他信息结合后，可用于识别该身份的信息。除本隐私政策和系统服务条款规定外，Forwardreceipts 应用程序不会使用您的个人数据。",
    collectionOverview:
      "我们可能会（直接和间接地）收集、使用、存储和传输有关您的各种个人数据。有关 Forwardreceipts 应用程序如何通过 Cookie、标识符和其他跟踪技术执行此操作的具体细节，请参阅下文的 Forwardreceipts 应用程序 Cookie 政策。我们收集、使用、存储和传输的个人数据类别归纳如下：",
    labelDataYouProvide: "您提供的数据。 ",
    descDataYouProvide:
      "账户注册信息（如姓名、电子邮件地址和电话号码）、上传的收据/图像以及付款或费用记录。",
    labelAutoCollectedData: "自动收集的数据。 ",
    descAutoCollectedData:
      "设备信息（包括操作系统和设备 ID）、使用日志和 Cookie/跟踪数据。",
    labelThirdPartyData: "第三方数据（如果适用）。 ",
    descThirdPartyData: "由支付网关或分析服务提供商提供的相关数据。",
    specialCategoryNotice:
      "我们不会收集有关您的任何“特殊类别个人数据”（这包括有关您的种族或民族、宗教或哲学信仰、性生活、性取向、政治观点、工会会员资格、健康信息以及遗传和生物特征数据的信息），也不会收集有关刑事定罪和违法行为的任何信息。",
    section2Title: "2. 我们如何使用您的数据？",
    useDataIntro:
      "Forwardreceipts 应用程序及我们的合作伙伴公司可能会通过以下方式使用您的个人数据：",
    useDataAccount: "促进在我们的网络上创建并保护您的账户；",
    useDataIdentify: "在我们的系统中将您识别为会员或非会员；",
    useDataAdmin: "管理并提供改进的 Forwardreceipts 服务管理；",
    useDataExperience:
      "改善您与 Forwardreceipts 服务互动时的体验质量，包括员工培训；",
    useDataWelcome:
      "向您发送欢迎电子邮件，以验证账户创建时提供的电子邮件地址的所有权；",
    useDataNotif:
      "向您发送管理性电子邮件和/或聊天通知，例如安全或支持与维护建议；",
    useDataFees: "收取欠我们的费用和款项；",
    useDataInquiries: "回复您有关就业机会或其他请求的查询，并解决争议；",
    useDataFeatures:
      "向您提供访问权限及有关自定义功能、新功能和合作伙伴集成的信息；",
    useDataEligibility: "确定您使用 Forwardreceipts 服务中各项目的资格；",
    useDataNewsletters: "向您提供纸质或电子通讯或调查；",
    useDataBusiness:
      "运营我们的业务，包括处理付款交易、管理和履行与您或第三方的合同、管理我们的公司治理、合规和审计实践，以及生成匿名或汇总数据；",
    useDataFraud:
      "预防和识别欺诈及其他非法活动，包括但不限于不时向您拨打电话，作为二级欺诈保护的一部分或征求您的反馈；",
    useDataIdentity:
      "作为遵守合作伙伴公司要求或适用法规的一部分，核实您的身份；",
    useDataDisputes: "解决争议并保护会员和第三方的权利；",
    useDataLegal: "回应索赔和法律程序（如传票和法院命令）；",
    useDataCompliance: "监控并强制执行对适用服务条款的遵守；",
    useDataStopIllegal:
      "预防或制止任何可能非法、不道德或具有法律诉讼性的活动；",
    useDataAccuracy:
      "将您提供的信息与第三方提供的信息进行比较，以确保准确性并进行核实；",
    useDataSupport:
      "为您提供支持并回复您的查询，包括调查和处理您的顾虑，以及监控和改进我们的响应并响应消费者权利要求；",
    useDataOther:
      "在收集您的个人信息时向您描述的其他情况；按照您的指示；遵守法律需要；以及",
    useDataMerger:
      "评估或进行合并、分立、重组、改组、解散，或以其他方式出售或转让我们的部分或全部资产，无论是作为持续经营企业还是作为破产、清算或类似程序的一部分，其中我们持有的有关消费者的个人信息属于转让资产。",
    essentialComm:
      "我们可能会使用您的个人数据向您发送重要的服务相关通知，例如购买确认、政策更新或服务条款变更。这些通知对于正常使用我们的服务是必要的。在法律允许的情况下，如果您选择不接收此类通讯，Forwardreceipts 保留终止服务的权利。如果您选择提供有关 Forwardreceipts 服务的反馈，我们可能会将该反馈用于商业目的，并根据本隐私政策处理其中包含的任何个人数据。",
    publicInfoNotice:
      "您选择通过 Forwardreceipts 服务公开提供的任何信息（包括个人数据）可能对其他会员或公众可见。即使您以后删除了此类信息，在服务的缓存或存档版本中，或者在其他会员已复制或存储该信息的情况下，该信息可能仍然可以访问。在某些情况下，我们还可能处理由企业会员提供的个人数据。在这些情况下，我们与受影响的个人没有直接关系。如果您认为您的个人数据以此类方式被收集并希望将其删除，请直接联系相关的企业会员。",
    pushNotifNotice:
      "我们还可能使用您的个人数据发送有关活动、促销或服务更新的推送通知。如果您不希望接收这些通讯，可以在设备设置中禁用它们。为了发送这些通知，我们可能会收集有限的设备信息，例如操作系统和设备标识符，仅用于通知目的。",
    section3Title: "3. 处理个人数据的法律依据",
    legalBasisIntro:
      "我们仅在拥有适用数据保护法下的有效法律依据时才处理您的个人数据。根据您的管辖区，处理的法律依据可能会有所不同。本节概述了我们依赖的法律依据，并解释了它们如何适用于不同地区。",
    section3_1Title: "3.1 欧盟 / 英国（GDPR，法规 (EU) 2016/679）",
    gdprIntro:
      "根据通用数据保护条例（GDPR，法规 (EU) 2016/679），我们基于以下法律依据处理个人数据：",
    gdprContractTitle: "a) 履行合同（GDPR 第 6(1)(b) 条）",
    gdprContractDesc:
      "我们处理您的个人数据是履行合同义务或提供您要求的服务所必需的。这包括但不限于：",
    gdprContractAccount: "创建和管理您的账户，并提供对应用程序的安全访问。",
    gdprContractExpenses: "记录、存储和处理您的费用、收据和付款信息。",
    gdprContractPayments: "促进与服务相关的付款、转账或其他财务操作。",
    gdprContractOutro:
      "如果没有此类处理，我们将无法提供应用程序的核心功能或履行我们的合同承诺。",
    gdprConsentTitle: "b) 同意（GDPR 第 6(1)(a) 条和第 7 条）",
    gdprConsentDesc:
      "某些处理活动需要您的明确同意，特别是那些对提供服务非严格必需的活动。例如：",
    gdprConsentMarketing: "接收营销通讯、时事通讯或促销通知。",
    gdprConsentTracking: "使用非服务必需的 Cookie、跟踪技术或分析工具。",
    gdprConsentOutro:
      "同意必须是自由给出的、具体的、知情的且明确的。您有权随时撤回同意。撤回不会影响撤回前基于同意进行的处理的合法性。",
    gdprInterestTitle: "c) 正当利益（GDPR 第 6(1)(f) 条）",
    gdprInterestDesc:
      "在为我们的正当利益所必需时，我们也可能处理个人数据，前提是这些利益不被您的权利和自由所抵消。正当利益通常包括：",
    gdprInterestImprove: "改进和优化我们的产品和服务。",
    gdprInterestSecurity: "确保应用程序及相关系统的安全性、完整性和可用性。",
    gdprInterestFraud: "防止未经授权的访问、欺诈或其他恶意活动。",
    gdprInterestOutro:
      "我们会进行平衡测试，以确保我们的正当利益不会对您的隐私权产生不成比例的影响。您可以随时联系我们的数据保护团队反对这种处理。",
    nonEULegalBasisNote:
      "对于位于欧盟/英国以外的用户，上述法律依据在当地法律下可能并非法律强制。然而，出于透明度和最佳实践的考虑，我们应用相同的原则，以确保您了解您的个人数据是如何被处理、存储和使用的。",
    section3_2Title: "3.2 美国 - 加利福尼亚州 (CCPA / CPRA)",
    ccpaIntro:
      "加利福尼亚州居民根据《加州消费者隐私法》(CCPA) 和《加州隐私权利法》(CPRA) 享有特定权利，其中可能包括：",
    ccpaRightKnow: "了解收集、使用、共享或出售哪些个人信息的权利。",
    ccpaRightDelete: "请求删除我们收集的个人信息的权利。",
    ccpaRightOptOut: "选择退出为针对性广告目的出售或共享个人信息的权利。",
    ccpaRightDiscrim: "不因行使隐私权而受到歧视的权利。",
    ccpaOutro:
      "我们根据这些权利处理加州居民的个人数据，并维护处理此类请求的程序。",
    section3_3Title: "3.3 新加坡 (PDPA)",
    pdpaIntro:
      "根据新加坡《个人数据保护法》(PDPA)，您对您的个人数据享有某些权利，包括：",
    pdpaRightInformed: "被告知收集、使用或披露您的个人数据的目的之权利。",
    pdpaRightAccess: "访问和更正我们持有的个人数据的权利。",
    pdpaRightWithdraw:
      "在适用情况下，撤回对收集、使用或披露个人数据的同意之权利。",
    pdpaOutro: "我们将按照 PDPA 的要求处理与这些权利相关的请求。",
    section4Title: "4. 我们如何共享数据",
    shareDataIntro:
      "我们重视您的隐私，并致力于负责任地处理您的个人数据。我们仅在下述有限的情况下，并始终根据适用法律共享您的个人数据。",
    section4_1Title: "4.1 服务提供商和业务合作伙伴",
    serviceProviderIntro:
      "我们可能会与协助我们运营服务和履行合同义务的受信任第三方服务提供商和业务合作伙伴共享您的个人数据。这些提供商可能包括但不限于：",
    labelCloud: "云托管和存储提供商 ",
    descCloud: "（用于应用程序和数据的安全存储和托管）；",
    labelPayment: "支付处理器 ",
    descPayment: "（促进交易、报销、工资单或其他财务操作）；",
    labelAnalytics: "分析提供商 ",
    descAnalytics: "（帮助我们更好地了解使用趋势并改进我们的产品和服务）；",
    labelIT: "IT 和安全提供商 ",
    descIT: "（用于系统维护、技术支持和欺诈预防）。",
    serviceProviderOutro:
      "这些服务提供商仅出于代表我们履行服务的目的被授予访问您个人数据的权限，并且在合同上有义务不为任何其他目的披露、使用或保留您的信息。",
    section4_2Title: "4.2 法律和监管要求",
    legalReqDesc:
      "当法律、法规或法律程序要求时，或者为了回应公共当局的有效请求（包括遵守国家安全或执法要求），我们可能会披露您的个人数据。具体而言，这可能包括回应传票、法院命令、搜查令或其他来自主管政府或监管机构的合法请求。",
    legalReqFaithIntro:
      "当我们真诚地认为披露对以下方面是必要时，我们也可能披露个人数据：",
    legalReqProtect: "保护和捍卫我们的权利、财产或用户的安全；",
    legalReqInvestigate: "预防或调查与我们服务相关的潜在不当行为；",
    legalReqLiability: "防止承担法律责任。",
    section4_3Title: "4.3 不出售个人数据",
    noSaleDesc:
      "我们不会将您的个人数据出售、出租或交易给第三方。对于加利福尼亚州居民，为了遵守《加州消费者隐私法》(CCPA) 和《加州隐私权利法》(CPRA)，我们确认我们不参与加州法律定义的“出售”或“共享”个人数据的行为。",
    noSaleChangeNotice:
      "尽管如此，如果我们的做法在未来发生变化，我们将相应更新本隐私政策，并在我们的网站或应用程序上提供清晰且显著的“",
    doNotSellLink: "请勿出售或共享我的个人信息",
    noSaleOutro: "”链接，按照加州法律的要求执行。",
    section4_4Title: "4.4 汇总或去标识化数据",
    aggDataDesc:
      "我们可能会共享无法合理用于识别您身份的汇总或去标识化信息。此类数据可用于研究、分析、营销或业务开发目的，并可无限制地与第三方共享。",
    section5Title: "5. 国际数据传输",
    transferIntro:
      "您的个人数据可能会在您居住国以外的国家存储、处理和维护，包括但不限于新加坡、美国以及欧洲经济区（“EEA”）以外的国家。通过使用我们的服务，您承认并同意将您的个人数据传输到可能不具备与您管辖区同等数据保护法律的国家。",
    gdprTransferNotice:
      "对于位于欧盟/英国的用户，Expensify 确保此类跨境传输符合适用的数据保护法律，包括通用数据保护条例 (GDPR)。具体而言，我们实施以下一项或多项法律机制，以在国际传输期间保护您的个人数据：",
    labelSCC: "标准合同条款 (SCCs)： ",
    descSCC:
      "我们依靠欧盟委员会批准的 SCC 作为将个人数据传输到 EEA 以外地区的法律依据，确保有适当的保障措施和合同义务来保护您的权利和个人信息。",
    labelAdequacy: "充分性认定： ",
    descAdequacy:
      "在适用情况下，我们仅将数据传输到被欧盟委员会或相关机构认定为提供充分数据保护水平的国家。",
    labelSafeguards: "其他适当保障措施： ",
    descSafeguards:
      "在某些情况下，我们可能会实施其他措施，如约束性公司规则、数据传输协议或其他适用法律认可的保障措施，以确保您的数据得到与 GDPR 要求一致的保护。",
    partnerContractNotice:
      "我们还确保代表我们处理个人数据的合作伙伴和服务提供商在合同上有义务根据本隐私政策和适用法律维护您数据的机密性、完整性和安全性。",
    nonEUTransferNotice:
      "对于欧盟/英国以外的用户，包括新加坡、美国和其他管辖区，本条款提供了有关潜在国际数据传输的透明度。虽然具体的法律保障措施可能因当地法律而异，但我们仍致力于保护您的个人数据，并在传输和存储过程中实施合理的安全措施。",
    transferConsent:
      "通过使用我们的服务，您同意这些传输以及所述保护您个人数据的措施。",
    section6Title: "6. 数据保留",
    retentionIntro:
      "Forwardreceipts 仅在实现本隐私政策所述收集目的所需的时间内保留个人数据，并遵守适用的法律、会计和监管要求。",
    retentionDeletionNotice:
      "当您删除个人账户时，与该账户相关的所有个人数据将在 ",
    retentionDays: "[30] ",
    retentionDeletionSuffix:
      "天内永久删除，除非法律要求保留或出于正当商业目的。点击",
    retentionLabelHere: "此处",
    corporateDataNotice:
      "了解有关账户删除的更多详情。请注意，您上传到公司或组织账户的任何收据或相关数据仍将作为该组织企业财务记录的一部分供其访问。此类保留的数据在适用情况下可能会被匿名化或去标识化，以最大限度地减少与您个人身份的任何关联。",
    retentionPurposeIntro:
      "Forwardreceipts 可能会保留和处理必要的有限数据，以便：",
    retentionLegal: "遵守法律义务、争议解决和协议执行。",
    retentionAudit: "根据法律或法规要求维护审计日志或交易记录。",
    retentionCorporate:
      "根据 Forwardreceipts 服务条款履行我们企业会员的数据保留要求。",
    secureDeletion:
      "我们使用安全的删除和去标识化方法，确保在不再需要个人数据时将其永久安全地销毁。",
    corporateContactNotice:
      "如果您隶属于企业会员，请直接联系您的组织，了解有关其针对成员生成内容的具体数据保留和管理政策的详情。",
    section7Title: "7. 选择/退出",
    choiceOptOutDesc:
      "Expensify 为您提供了接收有关我们公司、产品和服务的不同类型通讯和信息的选择。您可以订阅电子报或其他出版物；您也可以选择通过电子邮件或短信接收我们的营销通讯和其他特别优惠。您还可以选择通过短信与其他会员和非会员沟通。如果您想随时更改通讯偏好，我们在可用处提供了取消订阅链接和退出机制供您使用。您也可以从您的账户中访问并管理您的偏好。",
    section8Title: "8. Cookie 政策及跟踪技术的使用",
    cookieIntro:
      "当您与我们的网站或应用程序互动时，我们旨在使您的体验简单、高效且个性化。为此，我们及我们的受信任合作伙伴使用行业标准跟踪技术，包括 Cookie、像素、网络信标、Flash Cookie、移动标识符和类似工具（统称为“Cookie”或“跟踪技术”）。通过使用我们的服务，您同意按照本政策所述使用这些技术。",
    section8_1Title: "8.1 什么是 Cookie，它们能持续多久？",
    cookieDef:
      "Cookie 是在您访问网站或使用移动应用程序时存储在您的浏览器或设备上的小型文本文件或数据片段。它们允许我们存储并有时跟踪有关您使用我们服务的信息。",
    sessionCookies:
      "会话 Cookie 仅在您的浏览会话期间持续，并在您关闭浏览器或退出应用程序后过期。",
    persistentCookies:
      "持久性 Cookie 会一直保留，直到过期或被您或您的浏览器删除。",
    partyCookies:
      "第一方 Cookie 由我们直接设置，而第三方 Cookie 由外部提供商（如分析或广告合作伙伴）设置。这些第三方可能会在多个网站或应用程序中识别您的设备。",
    section8_2Title: "8.2 其他跟踪技术",
    otherTrackingIntro: "除 Cookie 外，我们还可能使用：",
    webBeacons:
      "网络信标（或“透明 GIF”）——嵌入在我们的内容中的小型图形，帮助我们衡量参与度和使用情况。",
    flashCookies:
      "Flash Cookie / 本地共享对象 (LSOs) —— 用于存储设置和使用数据。",
    mobileIds:
      "移动标识符 —— 例如苹果的 IDFA 或安卓的 UDID，用于实现与应用程序相关的分析、广告和个性化。",
    section8_3Title: "8.3 我们如何使用 Cookie",
    useCookiesIntro: "我们使用 Cookie 和类似技术来：",
    useCookiesOperate: "运营并保护我们的网站和应用程序；",
    useCookiesRecognize: "当您返回时识别您并个性化您的体验；",
    useCookiesImprove: "了解使用趋势并改进功能、性能和服务交付；",
    useCookiesAds: "提供量身定制的广告并衡量此类广告的效果（基于兴趣的广告）；",
    useCookiesAnalytics:
      "通过将使用信息链接到您的账户（如果适用），实现分析和故障排除。",
    cookieCategoriesIntro: "我们使用的 Cookie 通常分为以下几类：",
    labelNecessary: "绝对必要的 Cookie ",
    descNecessary:
      "—— 对于核心功能（如账户登录、安全区域、交易或账单）至关重要。",
    labelPerformance: "性能/分析 Cookie ",
    descPerformance: "—— 衡量访客活动、站点导航和参与度，帮助我们优化服务。",
    labelFunctionality: "功能性 Cookie ",
    descFunctionality:
      "—— 记住您的偏好（例如语言、地区）并启用社交媒体插件或小组件。",
    labelTargeting: "针对性/广告 Cookie ",
    descTargeting: "—— 记录访问和浏览行为，以投放更相关的广告并跟踪广告效果。",
    section8_4Title: "8.4 您的选择",
    yourChoicesIntro: "您可以控制 Cookie 和跟踪技术的使用：",
    section8_4_1Title: "8.4.1 浏览器和设备设置",
    browserSettingsDesc:
      "大多数浏览器和移动设备会自动接受 Cookie，但您可以修改设置以阻止或在放置 Cookie 时通知您。主流浏览器（如 Chrome、Firefox、Safari、Microsoft Edge）的指南在线可用。阻止 Cookie 可能会限制我们服务的某些功能。",
    section8_4_2Title: "8.4.2 行为广告",
    behavioralAdsDesc:
      "我们可能与第三方合作投放基于兴趣的广告。这些提供商可能会使用 Cookie 收集有关您在不同网站上的浏览活动的信息。您可以通过以下资源退出此类做法：",
    naiOptOut: "网络广告倡议 (NAI) 退出",
    daaOptOut: "数字广告联盟 (DAA) 退出",
    euCookieLink: "对于欧盟/英国用户：可在 [链接] 获取 Cookie 偏好工具。",
    nonTargetedAdsNotice:
      "请注意，即使在退出后，您仍将看到一般的（非针对性）广告。",
    section8_4_3Title: "8.4.3 分析",
    analyticsDesc:
      "我们使用分析服务（如 Google Analytics）和移动分析软件来了解使用情况并改进功能。这些工具可能会记录事件、性能数据和汇总趋势，但不会与个人身份信息相关联。您可以通过安装 [Google Analytics 退出浏览器插件] 来退出 Google Analytics。",
    section8_5Title: "8.5 请勿追踪 (DNT)",
    dntDesc:
      "某些浏览器包含“请勿追踪”设置。目前，由于缺乏统一的行业标准，我们不对 DNT 信号做出回应。",
    section9Title: "9. 您的权利",
    rightsIntro:
      "Forwardreceipts 认识到用户在收集、使用和处理其个人数据方面享有某些权利。这些权利因您的管辖区而异：",
    pdpaRightsTitle: "对于新加坡用户（根据《个人数据保护法》PDPA）：",
    pdpaRightsDesc:
      "您有权访问 Forwardreceipts 持有的您的个人数据，要求更正任何不准确或不完整的信息，并撤回您对收集、使用或披露您的个人数据的同意，但须遵守任何法律或合同限制。",
    ccpaRightsTitle:
      "对于美国用户（根据《加州消费者隐私法》/《加州隐私权利法》CCPA/CPRA）：",
    ccpaRightsDesc:
      "您有权了解我们收集、使用、共享或出售哪些个人数据。您可以请求删除您的个人数据，但须遵守适用法律规定的某些例外情况。如果适用，您还可以通过使用本隐私政策中提供的“请勿出售我的信息”链接行使选择退出出售个人数据的权利。",
    gdprRightsTitle:
      "对于欧盟或英国用户（根据通用数据保护条例 GDPR / 英国 GDPR）：",
    gdprRightsDesc:
      "您有权访问您的个人数据，要求更正不准确之处，要求删除您的个人数据，并要求限制对您个人数据的处理。您还享有数据可移植性的权利，并有权反对基于正当利益或同意的某些处理活动，包括与营销相关的处理。",
    allUsersRightsTitle: "对于所有用户，无论其位置如何：",
    allUsersRightsDesc:
      "您可以请求删除您的 Forwardreceipts 账户及所有相关的个人数据，或请求以结构化、常用且机器可读的格式提供您个人数据的便携式副本。Forwardreceipts 将采取合理措施根据适用法律响应此类请求。",
    exerciseRightsNotice:
      "要行使这些权利，请使用本隐私政策中提供的联系信息联系我们。我们可能需要在履行您的请求之前核实您的身份，以确保保护您的个人数据。",
    section10Title: "10. 安全",
    securityIntro:
      "Forwardreceipts 认真对待您的个人数据保护，并实施了一系列行业标准的技术、管理和组织措施，以保护其免受未经授权的访问、使用、披露、篡改或销毁。",
    securityAuthNotice:
      "访问您的账户需要身份验证，例如密码或其他安全登录机制，您应保持机密且不与未经授权的个人共享。虽然我们努力维持最高级别的安全性，但没有任何数据传输或存储方法可以保证绝对保护。",
    securityContactNotice:
      "如果您对个人数据的安全性有任何顾虑或疑问，请通过 support@forwardreceipts.com 与我们联系。Forwardreceipts 将根据适用的隐私和数据保护法律审查并回应您的查询。",
    section11Title: "11. 儿童隐私",
    childrenIntro:
      "Forwardreceipts 服务和应用程序不适合 13 岁以下的儿童或适用管辖区要求的最低年龄以下的儿童使用。我们不会故意收集此年龄阈值以下儿童的个人数据。",
    childrenDeleteNotice:
      "如果我们意识到无意中收集了适用年龄以下儿童的个人数据，我们将立即采取步骤从我们的系统中删除此类信息。如果父母或法定监护人认为其孩子通过 Forwardreceipts 服务或应用程序提供了个人数据，请通过 support@forwardreceipts.com 与我们联系，以便我们及时删除数据。",
    childrenCompliance:
      "我们遵守适用的儿童隐私法律，包括美国的《儿童在线隐私保护法》(COPPA) 以及其他管辖区的类似立法。任何未达到相关年龄的儿童在没有父母或监护人同意的情况下不得提交个人信息。",
    childrenParentalMonitoring:
      "Forwardreceipts 还鼓励父母和监护人积极监控其孩子的在线活动，并帮助执行这些隐私保护措施。",
    section12Title: "12. 订阅与计费",
    section12_1Title: "12.1 订阅服务",
    subServicesDesc:
      "我们的应用程序可能会提供付费订阅计划，以提供对附加功能或高级内容的访问。每个订阅计划在购买前都会清楚列明其价格、计费周期和续订条款。",
    subPlatformNotice:
      "如果您通过 Apple App Store 或 Google Play Store 订阅，付款和续订过程将完全由相应平台根据其条款和政策处理。",
    section12_2Title: "12.2 自动续订",
    autoRenewalDesc:
      "所有定期订阅均设置为在每个计费周期结束时自动续订，除非在续订日期前至少 24 小时取消。续订费用将使用您在购买时选择的付款方式从您的 Apple ID 账户或 Google Play 账户中扣除。",
    priceChangeNotice:
      "Apple 或 Google 会提前通知您任何价格变动，续订将按新费率继续，除非您在下一个计费周期前取消订阅。",
    section12_3Title: "12.3 管理和取消订阅",
    manageSubIntro: "您可以随时管理或取消订阅：",
    appleSubLabel: "Apple 用户：前往设置 > [您的姓名] > 订阅，或访问",
    googleSubLabel: "Google Play 用户：前往 Google Play > 账户 > 订阅，或访问",
    cancelSubEffect:
      "如果您取消，您将保留对高级功能的访问权限，直到当前计费周期结束。之后，您的订阅将不再自动续订，也不会再产生进一步费用。",
    section12_4Title: "12.4 退款",
    refundsDesc:
      "所有付款和退款均由 Apple 或 Google 根据其各自的退款政策处理。我们不直接处理退款。",
    refundsInquiry: "如需申请退款，请访问：",
    labelApple: "Apple： ",
    labelGoogle: "Google Play： ",
    section12_5Title: "12.5 合规与数据处理",
    noPaymentStorage:
      "我们不直接存储或有权访问您的完整付款信息。所有交易均由 Apple 或 Google 在其各自的隐私和数据保护框架下安全处理。",
    subDataNotice:
      "我们收到的任何信息（如购买确认或订阅状态）均按照本隐私政策及适用的数据保护法律（包括 GDPR 和 CCPA）进行处理。",
    subMetadataNotice:
      "我们仅出于服务持续性、分析和客户支持的目的保留非敏感的交易元数据（如订阅类型、开始和结束日期）。",
    section13Title: "13. 联系我们",
    contactIntro:
      "如果您对本隐私政策有任何意见、疑问或投诉，或者如果您认为 Forwardreceipts 未能履行其在处理、使用或披露您的个人数据方面的义务，您可以通过 support@forwardreceipts.com 与我们联系。我们将根据适用的隐私和数据保护法律审查并回应您的查询。",
    contactPIINotice:
      "您承认并同意，在通过电子邮件、聊天或其他方式联系 Forwardreceipts 时，除非必要，否则不应在通讯中包含任何个人身份信息。如果包含此类信息，Forwardreceipts 对该通讯中披露的信息不承担任何法律义务或责任。",
  },
};
